<template>
  <div class="pdf-overlay">
    <infinity-loading />
    <p class="pdf-overlay__text">{{ $t("metrics.preparingPdf") }}</p>
  </div>
</template>

<script>
import InfinityLoading from "@/components/rubrics/newRubric/components/infinity-loading.vue";

export default {
  name: "MetricsPdfOverlay",
  components: { InfinityLoading },
};
</script>

<style scoped lang="scss">
.pdf-overlay {
  position: absolute;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(2px);

  &__text {
    margin: 0;
    font-size: var(--typography-font-size-fs-200);
    font-weight: var(--typography-font-weight-fw-500);
    color: var(--color-text-neutral-secondary);
  }
}
</style>
